import type { Props } from './types';

const GenAILogo = ({ className }: Props) => (
  <img
    alt="logo"
    className={className}
    src="https://cdn-cms-uploads.picsart.com/cms-uploads/7f9e8f46-5914-4e7b-adcf-058ad4c9391c.webp?type=webp&to=min&r=300"
  />
);

export default GenAILogo;
